import { useParams } from 'react-router';
import { isEmpty } from 'lodash';
import { dispatch, useSelector } from '@/stores';
//
import { Button, InputAdornment, Stack, TextField } from '@mui/material';
import {
  SummaryFieldLabel,
  SummaryFieldText,
  SummaryFieldPrice,
} from './SummaryTypographyComponents';
import { setManualBaseRate } from '@/features/bookings-management/slices';
//
import { fCurrency } from '@/utils/formatNumber';
//

export default function SummaryCleaningService() {
  const { bookingId } = useParams();
  const booking = useSelector((state) => state.booking);
  const canSetManualPrice =
    !bookingId &&
    !!booking.client?.id &&
    !isEmpty(booking.address) &&
    !isEmpty(booking.selectedServiceVariant);
  const shouldShowPriceInputValue =
    booking.cleanDetails.baseRate > 0 ||
    canSetManualPrice ||
    Boolean(bookingId);
  const priceInputValue = shouldShowPriceInputValue
    ? booking.cleanDetails.baseRate
    : '';

  return (
    <Stack direction="column" gap={2}>
      <SummaryFieldLabel>Cleaning services</SummaryFieldLabel>

      <Stack direction="row" spacing={1} alignItems="flex-start">
        <TextField
          label="Price per hour"
          value={priceInputValue}
          disabled={!canSetManualPrice}
          type="number"
          size="small"
          inputProps={{ min: 0, step: 0.01 }}
          InputProps={{
            startAdornment: <InputAdornment position="start">£</InputAdornment>,
          }}
          onChange={(event) => {
            const parsedPrice = Number(event.target.value);
            if (event.target.value === '') {
              dispatch(setManualBaseRate(null));
              return;
            }
            if (Number.isFinite(parsedPrice) && parsedPrice >= 0) {
              dispatch(setManualBaseRate(parsedPrice));
            }
          }}
          helperText={
            canSetManualPrice || bookingId
              ? undefined
              : 'Select client, address and service first'
          }
          fullWidth
        />
        {booking.cleanDetails.manualBaseRateTouched && (
          <Button
            size="small"
            color="inherit"
            onClick={() => dispatch(setManualBaseRate(null))}
            sx={{ mt: 0.5, whiteSpace: 'nowrap' }}
          >
            Reset
          </Button>
        )}
      </Stack>

      {booking.cleanDetails.hours > 0 && (
        <Stack direction="row" spacing={2} justifyContent="space-between">
          <SummaryFieldText>
            {booking.cleanDetails.hours} hr *{' '}
            {fCurrency(booking.cleanDetails.baseRate)}
          </SummaryFieldText>
          <SummaryFieldPrice>
            {fCurrency(
              booking.cleanDetails.hours * booking.cleanDetails.baseRate
            )}
          </SummaryFieldPrice>
        </Stack>
      )}
    </Stack>
  );
}
